import color from "@constants/color";
import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import Text from "@components/CustomText";
import { useNavigation } from "@react-navigation/native";

const OfdListFooter = ({ title, value }) => {
  const navigation = useNavigation();
  return (
    <TouchableOpacity
      testID="Ofd-list-footer"
      disabled={value === 0}
      onPress={() => {
        navigation.navigate("CpDeliveryRoutes");
      }}
      style={styles.container}
    >
      <Text variant="title_16" style={styles.text}>
        {title}
      </Text>
      <Text variant="title_16" style={styles.text}>
        {value}
      </Text>
    </TouchableOpacity>
  );
};

export default OfdListFooter;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderRadius: 10,
    padding: 16,
    paddingVertical: 12,
    margin: 16,
    marginVertical: 8,
    backgroundColor: "white",
    borderColor: color.plain_red,
    borderWidth: 1,
  },
  text: {
    color: color.plain_red,
  },
});
